/**
 * mostly tweaked using new components from DetailRow component
 */
import React from 'react';
import styled from 'styled-components';
import {
  Icon,
  type IconName,
  SemanticColorName,
} from '@brokerbay/elements-web';
import {
  Icon as NewIcon,
  type IconName as NewIconName,
} from '@bb/elements-web-rebranding';
import { featureEnabled } from 'utils';
import { BODY_MARGIN_LEFT } from '../../constants';

type InfoContainerStyleOptions = {
  iconPaddingTop?: number;
};
const InfoContainer: React.FC<
  InfoContainerStyleOptions & {
    colorName?: SemanticColorName;
    icon: NewIconName;
  }
> = ({ colorName, icon, iconPaddingTop, children, ...props }) => (
  <RowContainer {...props}>
    <IconContainer $iconPaddingTop={iconPaddingTop}>
      {featureEnabled('supraRebrandingFeature', 1) ? (
        <NewIcon
          icon={icon as NewIconName}
          size={20}
          color={colorName === 'green' ? 'success' : colorName}
        />
      ) : (
        <Icon icon={icon as IconName} size={20} color={colorName} />
      )}
    </IconContainer>
    <BodyContainer>{children}</BodyContainer>
  </RowContainer>
);
export default InfoContainer;

const RowContainer = styled.div`
  display: flex;
  &:not(:last-child) {
    margin-bottom: 22px;
  }
  max-width: 80%;
`;
const IconContainer = styled.div<{
  $iconPaddingTop?: number;
}>`
  display: flex;
  ${({ $iconPaddingTop }) =>
    $iconPaddingTop && `padding-top: ${$iconPaddingTop}px;`}
`;
const BodyContainer = styled.div`
  margin-left: ${BODY_MARGIN_LEFT}px;
  font-size: 14px;
`;
